export type PatchNoteKind = "New" | "Improved" | "Fixed";

export type PatchNoteItem = {
  kind: PatchNoteKind;
  text: string;
};

export type PatchNoteEntry = {
  version: string;
  date: string;
  title: string;
  summary: string;
  items: PatchNoteItem[];
};

export const patchNotes: PatchNoteEntry[] = [
  {
    version: "September 2026 privacy update",
    date: "September 9, 2026",
    title: "More private navigation analytics",
    summary:
      "Navigation analytics now respect browser privacy preferences and keep personal route details out of event data.",
    items: [
      {
        kind: "Fixed",
        text: "Settings are fetched only after the client is ready, avoiding anonymous settings requests on the sign-in screen. Failed initial settings reads retain local settings.",
      },
      {
        kind: "Improved",
        text: "Do Not Track and Global Privacy Control suppress analytics, including registration-link intent.",
      },
      {
        kind: "Fixed",
        text: "Pageviews follow navigation without duplicate events for query or fragment changes. Server and channel identifiers are replaced with route templates, and development routes are excluded.",
      },
    ],
  },
  {
    version: "v0.14.0",
    date: "July 15, 2026",
    title: "Clearer voice and desktop controls",
    summary:
      "This release improves screen sharing and everyday navigation across the web and desktop clients.",
    items: [
      {
        kind: "New",
        text: "Screen sharing now has a local preview in the floating call card, so you can verify what you are broadcasting while browsing elsewhere.",
      },
      {
        kind: "Improved",
        text: "The floating voice card expands while sharing to keep the preview and call controls usable.",
      },
      {
        kind: "Improved",
        text: "Authentication, navigation, voice rooms, and desktop behavior include the broader usability and accessibility improvements from this release line.",
      },
      {
        kind: "Fixed",
        text: "Screen-share controls and several high-friction voice and desktop layout issues were repaired.",
      },
    ],
  },
  {
    version: "v0.13.0",
    date: "June 4, 2026",
    title: "Voice cleanup and production polish",
    summary:
      "This release makes voice rooms more predictable, trims rough edges from the client, and tightens the production release path.",
    items: [
      {
        kind: "Improved",
        text: "Voice channels now wait for an explicit join instead of pulling you in while you browse.",
      },
      {
        kind: "Improved",
        text: "Participant controls are cleaner, with better mute and volume behavior in active voice rooms.",
      },
      {
        kind: "Fixed",
        text: "Leaving, switching, and rejoining voice sessions is more reliable across normal navigation.",
      },
      {
        kind: "Fixed",
        text: "Production smoke checks now cover the core login path before a release is considered ready.",
      },
    ],
  },
  {
    version: "v0.12.1",
    date: "May 20, 2026",
    title: "Discovery and media fixes",
    summary:
      "A maintenance release focused on discovery clarity, media handling, and the service stability needed for regular use.",
    items: [
      {
        kind: "Improved",
        text: "Discovery listings use clearer labels so servers are easier to scan.",
      },
      {
        kind: "Fixed",
        text: "Media and GIF handling received production fixes for smoother sharing.",
      },
      {
        kind: "Fixed",
        text: "Voice disconnect handling was hardened to reduce stale voice state.",
      },
    ],
  },
];
